import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

type Language = 'en' | 'ar';

const translations = {
  en: {
    home: 'Home', gallery: 'Gallery', about: 'About', contact: 'Contact', login: 'Login', register: 'Register', logout: 'Logout', admin: 'Admin', myOrders: 'My Orders', cart: 'Cart', emptyCart: 'Your cart is empty', checkout: 'Checkout', totalPrice: 'Total',
    heroTitle: 'Where Dreams Meet Canvas',
    heroSubtitle: 'Discover unique handcrafted paintings that bring beauty and emotion into your space',
    explorePaintings: 'Explore Paintings', aboutArtist: 'About the Artist',
    galleryTitle: 'Art Gallery', gallerySubtitle: 'Each painting tells a unique story',
    allCategories: 'All', flowers: 'Flowers', landscapes: 'Landscapes',
    fantasy: 'Fantasy', animals: 'Animals', abstract: 'Abstract',
    searchArtworks: 'Search artworks...', noArtworks: 'No artworks found',
    addToCart: 'Add to Cart', price: 'Price', viewDetails: 'View Details',
    artworkDetails: 'Artwork Details', description: 'Description', category: 'Category',
    orderNow: 'Order Now', backToGallery: 'Back to Gallery',
    orderTitle: 'Complete Your Order', fullName: 'Full Name', address: 'Delivery Address',
    phone: 'Phone Number', notes: 'Additional Notes', submitOrder: 'Send Order via WhatsApp',
    orderSuccess: 'Order submitted successfully!',
    aboutTitle: 'About Melody Art Gallery',
    aboutStory: 'Every brushstroke tells a story, every color speaks an emotion.',
    aboutDescription: 'Our gallery features handcrafted paintings spanning flowers, landscapes, fantasy worlds, and nature.',
    ourVision: 'Our Vision',
    visionText: 'To create a world where art is accessible to everyone.',
    contactTitle: 'Get in Touch', contactSubtitle: "We'd love to hear from you",
    yourName: 'Your Name', yourEmail: 'Your Email', message: 'Message',
    sendMessage: 'Send Message', followUs: 'Follow Us', messageSent: 'Message sent!',
    loginTitle: 'Welcome Back', registerTitle: 'Create Account',
    email: 'Email', password: 'Password', confirmPassword: 'Confirm Password',
    noAccount: "Don't have an account?", hasAccount: 'Already have an account?',
    signUp: 'Sign Up', signIn: 'Sign In',
    adminDashboard: 'Admin Dashboard', manageArtworks: 'Artworks', manageOrders: 'Orders',
    manageUsers: 'Users', settings: 'Settings', addArtwork: 'Add Artwork',
    editArtwork: 'Edit', deleteArtwork: 'Delete', title: 'Title', save: 'Save',
    cancel: 'Cancel', confirm: 'Confirm', delete: 'Delete', edit: 'Edit',
    status: 'Status', pending: 'Pending', confirmed: 'Confirmed',
    paymentConfirmed: 'Payment Confirmed', shipped: 'Shipped',
    delivered: 'Delivered', cancelled: 'Cancelled',
    whatsappNumber: 'WhatsApp Number', totalOrders: 'Total Orders',
    totalArtworks: 'Total Artworks', totalUsers: 'Total Users', revenue: 'Revenue',
    notifications: 'Notifications', noNotifications: 'No notifications',
    orderConfirmed: 'Your order has been confirmed!', orderShipped: 'Your order has been shipped!',
    markAsRead: 'Mark as read', lightMode: 'Light', darkMode: 'Dark',
    footerText: '© 2024 Melody Art Gallery', madeWithLove: 'Made with ♥ for art',
    loading: 'Loading...', error: 'An error occurred', success: 'Success', currency: '$',
    featuredTitle: 'Featured Artworks', featuredSubtitle: 'Handpicked masterpieces from our collection',
    instagramTitle: 'Follow Our Journey', instagramSubtitle: 'Stay connected through Instagram',
  },
  ar: {
    home: 'الرئيسية', gallery: 'المعرض', about: 'عن الفنانة', login: 'دخول', register: 'تسجيل', logout: 'خروج', admin: 'لوحة التحكم', myOrders: 'طلباتي', contact: 'تواصل', cart: 'السلة', emptyCart: 'السلة فارغة', checkout: 'إتمام الطلب', totalPrice: 'المجموع',
    heroTitle: 'حيث تلتقي الأحلام بالقماش',
    heroSubtitle: 'اكتشفي لوحات فنية يدوية فريدة تضيف الجمال والعاطفة إلى مساحتك',
    explorePaintings: 'استكشفي اللوحات', aboutArtist: 'عن الفنانة',
    galleryTitle: 'معرض الفنون', gallerySubtitle: 'كل لوحة تحكي قصة فريدة',
    allCategories: 'الكل', flowers: 'زهور', landscapes: 'مناظر طبيعية',
    fantasy: 'فانتازيا', animals: 'حيوانات', abstract: 'تجريدي',
    searchArtworks: 'ابحثي عن لوحات...', noArtworks: 'لا توجد لوحات',
    addToCart: 'أضيفي للسلة', price: 'السعر', viewDetails: 'عرض التفاصيل',
    artworkDetails: 'تفاصيل اللوحة', description: 'الوصف', category: 'الفئة',
    orderNow: 'اطلبي الآن', backToGallery: 'العودة للمعرض',
    orderTitle: 'أكملي طلبك', fullName: 'الاسم الكامل', address: 'عنوان التوصيل',
    phone: 'رقم الهاتف', notes: 'ملاحظات إضافية', submitOrder: 'أرسلي الطلب عبر واتساب',
    orderSuccess: 'تم تقديم الطلب بنجاح!',
    aboutTitle: 'عن معرض ميلودي', aboutStory: 'كل ضربة فرشاة تحكي قصة.',
    aboutDescription: 'يضم معرضنا لوحات يدوية فريدة.',
    ourVision: 'رؤيتنا', visionText: 'خلق عالم يكون فيه الفن متاحاً للجميع.',
    contactTitle: 'تواصلي معنا', contactSubtitle: 'نحب أن نسمع منك',
    yourName: 'اسمك', yourEmail: 'بريدك', message: 'الرسالة',
    sendMessage: 'أرسلي', followUs: 'تابعينا', messageSent: 'تم الإرسال!',
    loginTitle: 'مرحباً بعودتك', registerTitle: 'حساب جديد',
    email: 'البريد', password: 'كلمة المرور', confirmPassword: 'تأكيد كلمة المرور',
    noAccount: 'ليس لديك حساب؟', hasAccount: 'لديك حساب؟',
    signUp: 'سجلي', signIn: 'دخول',
    adminDashboard: 'لوحة التحكم', manageArtworks: 'اللوحات', manageOrders: 'الطلبات',
    manageUsers: 'المستخدمين', settings: 'الإعدادات', addArtwork: 'إضافة لوحة',
    editArtwork: 'تعديل', deleteArtwork: 'حذف', title: 'العنوان', save: 'حفظ',
    cancel: 'إلغاء', confirm: 'تأكيد', delete: 'حذف', edit: 'تعديل',
    status: 'الحالة', pending: 'قيد الانتظار', confirmed: 'مؤكد',
    paymentConfirmed: 'تم تأكيد الدفع', shipped: 'تم الشحن',
    delivered: 'تم التوصيل', cancelled: 'ملغي',
    whatsappNumber: 'رقم واتساب', totalOrders: 'إجمالي الطلبات',
    totalArtworks: 'إجمالي اللوحات', totalUsers: 'إجمالي المستخدمين', revenue: 'الإيرادات',
    notifications: 'الإشعارات', noNotifications: 'لا توجد إشعارات',
    orderConfirmed: 'تم تأكيد طلبك!', orderShipped: 'تم شحن طلبك!',
    markAsRead: 'تحديد كمقروء', lightMode: 'فاتح', darkMode: 'داكن',
    footerText: '© 2024 معرض ميلودي للفنون', madeWithLove: 'صنع بحب',
    loading: 'جاري التحميل...', error: 'حدث خطأ', success: 'تم', currency: '$',
    featuredTitle: 'لوحات مميزة', featuredSubtitle: 'روائع مختارة من مجموعتنا',
    instagramTitle: 'تابعي رحلتنا', instagramSubtitle: 'ابقي على تواصل عبر انستقرام',
  },
};

type TranslationKey = keyof typeof translations.en;

interface I18nContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: TranslationKey) => string;
  dir: 'ltr' | 'rtl';
}

const I18nContext = createContext<I18nContextType | null>(null);

export const I18nProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLangState] = useState<Language>(() => {
    const saved = localStorage.getItem('melody-lang');
    return (saved === 'ar' || saved === 'en') ? saved : 'en';
  });

  const setLang = useCallback((newLang: Language) => {
    setLangState(newLang);
    localStorage.setItem('melody-lang', newLang);
  }, []);

  const t = useCallback((key: TranslationKey) => {
    return translations[lang][key] || key;
  }, [lang]);

  const dir = lang === 'ar' ? 'rtl' : 'ltr';

  useEffect(() => {
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
  }, [dir, lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t, dir }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
};
